import { Component } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig
} from '@angular/material/legacy-dialog';
import { HeaderService } from '../../header.services';
import { BrowserService } from '../../browser.service';
import { AppComponent } from './../../../app.component';
import { NavigationEnd, Router } from '@angular/router';
import { Unsubscriber } from '../../unsubscriber/unsubscriber';
import { VersionService } from '../../services/version.services';
import { environment } from '../../../../environments/environment';
import { SubscribeOfferNewsletterDialogComponent } from '../../../shared/modals/subscribe-offer-newsletter/subscribe-offer-newsletter.component';

@Component({
  selector: 'brf-news-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends Unsubscriber {
  currentVersion: string;
  lastestVersion: string = '';
  isDifferentVersion: boolean = true;
  shouldShowFooter = true;
  year: number = new Date().getFullYear();

  constructor(
    private browserservice: BrowserService,
    private versionService: VersionService,
    private headerService: HeaderService,
    public dialog: MatDialog,
    private router: Router
  ) {
    super();
    this.currentVersion = environment.version;
    if (this.browserservice.isbrowser) {
      this.addSubscription(
        this.versionService.getLatestVersion().subscribe((ver: string) => {
          this.lastestVersion = ver;
          this.isDifferentVersion = ver && ver.length > 0 && ver !== this.currentVersion;
        })
      );

      router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (window.location.href.indexOf('#prenumerera') > 0) {
            this.openSubscribeModal();
          }
        }
      });
    }
  }

  ngOnInit(): void {
    this.addSubscription(this.headerService.showHeaderSubject.subscribe(flag => (this.shouldShowFooter = flag)));
  }
  openSubscribeModal() {
    const dialogConfig = new MatDialogConfig();
    //dialogConfig.disableClose = true;
    dialogConfig.maxHeight = '100vh';
    dialogConfig.autoFocus = true;
    dialogConfig.data = {};
    this.dialog.open(SubscribeOfferNewsletterDialogComponent, dialogConfig);
  }
  update() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        let pArr: Promise<boolean>[] = [];
        for (let registration of registrations) {
          pArr.push(registration.unregister());
        }
        if ('caches' in window) {
          caches.keys().then(function (keyList) {
            for (let k of keyList) pArr.push(caches.delete(k));
          });
        }
        Promise.all(pArr).then(result => {
          setTimeout(() => {
            location.reload();
          }, 500);
        });
      });
    }
  }

  showCookieSettings() {
    if (this.browserservice.isbrowser) {
      AppComponent.instance?.showCookieSettings();
    }
  }
}
